module.exports = __webpack_public_path__ + "img/boy.a4d78c7b.svg";